var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{class:{ hidden: true }},[_c('img',{class:{ big_img: _vm.big, small_img: _vm.small },attrs:{"src":_vm.imgurl,"alt":""}}),_c('div',{staticClass:"container"},_vm._l((_vm.text),function(item){return _c('p',{key:item,staticClass:"text"},[_vm._v(" "+_vm._s(item)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }